module.exports = __webpack_public_path__ + "kr.svg?472436a2cd7adcfb81854d5e9d45267b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/kr.svg
// module id = 1452
// module chunks = 0